
import './index.scss'
import { useRef, useState } from 'react'


const Newsletter = () => {
    const [status, setStatus] = useState(null)
    const emailRef = useRef()

    const handleSubmit = (e) => {
        e.preventDefault()
        setStatus('submitting')

        const formData = new FormData()
        formData.append('email', emailRef.current.value)
        formData.append('subject', 'Newsletter Subscription')

        fetch('https://formspree.io/f/xgozvoqg', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json'
            }
        }).then((response) => {
            if (response.ok) {
                setStatus('success')
                emailRef.current.value = ''
            } else {
                setStatus('error')
            }
        }).catch(() => {
            setStatus('error')
        })
    }

    return (
        <section className="newsletter-section">
            <div className="newsletter-content">
                <div className="text-content">
                    {/* Animated "Stay in the loop" */}
                    <h2>
                        Build Better Apps. Stay in the Loop.
                    </h2>
                    <p>
                        Join 500+ founders receiving our weekly iOS development insights, tips on launching your first app, and strategic advice.
                    </p>
                </div>

                <div className="form-content">
                    {status === 'success' ? (
                        <div className="success-message">
                            <h3>Thanks for joining! 🎉</h3>
                            <p>Check your inbox for a welcome email soon.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <input
                                ref={emailRef}
                                type="email"
                                name="email"
                                placeholder="Enter your email address"
                                required
                            />
                            <button type="submit" disabled={status === 'submitting'}>
                                {status === 'submitting' ? 'Joining...' : 'Subscribe'}
                            </button>
                            {status === 'error' && <p className="error-message">Something went wrong. Please try again.</p>}
                        </form>
                    )}
                    <p className="privacy-note">No spam. Unsubscribe anytime.</p>
                </div>
            </div>
        </section>
    )
}

export default Newsletter
